import type { JSX } from 'react';

interface SkeletonProps {
  readonly className?: string;
  /** Screen-reader label; loading is a state, not a decoration. */
  readonly label: string;
}

/** Skeletons, not spinners (CLAUDE.md §7.4). */
export function Skeleton({ className = '', label }: SkeletonProps): JSX.Element {
  return (
    <div
      aria-busy="true"
      aria-label={label}
      className={`shimmer rounded-[var(--radius-md)] ${className}`}
      role="status"
    />
  );
}
